/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VerifiedInputs */

const th_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันแล้ว`)
};

const en_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const ja_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認済み`)
};

const zh_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证`)
};

const es_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificada`)
};

const pt_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado`)
};

const id_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terverifikasi`)
};

const fr_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiée`)
};

const tl_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beripikado`)
};

const vi_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác minh`)
};

const ko_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증됨`)
};

const de_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigt`)
};

const ru_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждён`)
};

const tr_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulandı`)
};

const it_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificato`)
};

const pl_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowany`)
};

const uk_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтверджено`)
};

const hi_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापित`)
};

const ar_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موثَّق`)
};

const ms_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disahkan`)
};

const bn_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যাচাইকৃত`)
};

const zh_tw2_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已驗證`)
};

const zh_hk2_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已驗證`)
};

const ur_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصدیق شدہ`)
};

const fa_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأییدشده`)
};

const sw_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imehakikiwa`)
};

const nl_verified = /** @type {(inputs: VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestigd`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {VerifiedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const verified = /** @type {((inputs?: VerifiedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VerifiedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_verified(inputs)
	if (locale === "ja") return ja_verified(inputs)
	if (locale === "zh") return zh_verified(inputs)
	if (locale === "es") return es_verified(inputs)
	if (locale === "pt") return pt_verified(inputs)
	if (locale === "id") return id_verified(inputs)
	if (locale === "fr") return fr_verified(inputs)
	if (locale === "tl") return tl_verified(inputs)
	if (locale === "vi") return vi_verified(inputs)
	if (locale === "ko") return ko_verified(inputs)
	if (locale === "de") return de_verified(inputs)
	if (locale === "ru") return ru_verified(inputs)
	if (locale === "tr") return tr_verified(inputs)
	if (locale === "it") return it_verified(inputs)
	if (locale === "pl") return pl_verified(inputs)
	if (locale === "uk") return uk_verified(inputs)
	if (locale === "hi") return hi_verified(inputs)
	if (locale === "ar") return ar_verified(inputs)
	if (locale === "ms") return ms_verified(inputs)
	if (locale === "bn") return bn_verified(inputs)
	if (locale === "zh-TW") return zh_tw2_verified(inputs)
	if (locale === "zh-HK") return zh_hk2_verified(inputs)
	if (locale === "ur") return ur_verified(inputs)
	if (locale === "fa") return fa_verified(inputs)
	if (locale === "sw") return sw_verified(inputs)
	if (locale === "nl") return nl_verified(inputs)
	return en_verified(inputs)
});